import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.serverUrl = process.env.REACT_APP_SERVER_URL;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(this.serverUrl, {
        withCredentials: true
      });
      
      // 기본 이벤트 리스너 설정
      this.socket.on('connect', () => {
        console.log('서버에 연결되었습니다:', this.socket.id);
      });

      this.socket.on('disconnect', () => {
        console.log('서버 연결이 끊어졌습니다.');
      });

      this.socket.on('connect_error', (error) => {
        console.error('연결 오류:', error);
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  // 방 생성 (백엔드 이벤트 이름과 일치)
  createRoom(roomData) {
    if (this.socket) {
      this.socket.emit('create-room', roomData);
    }
  }

  // 방 참여 (백엔드 이벤트 이름과 일치)
  joinRoom(roomId, playerData) {
    if (this.socket) {
      this.socket.emit('join-room', { roomId, playerName: playerData.name, password: playerData.password });
    }
  }

  // 방 나가기 (백엔드 이벤트 이름과 일치)
  leaveRoom(roomId) {
    if (this.socket) {
      this.socket.emit('leave-room', { roomId });
    }
  }

  // 방 목록 조회
  getRooms() {
    if (this.socket) {
      this.socket.emit('get-rooms');
    }
  }

  // 방 정보 조회
  getRoomInfo(roomId) {
    if (this.socket) {
      this.socket.emit('room-info', { roomId });
    }
  }

  // 플레이어 준비 상태 변경
  toggleReady(roomId, playerId) {
    if (this.socket) {
      this.socket.emit('toggle-ready', { roomId, playerId });
    }
  }

  // 게임 시작
  startGame(roomId) {
    if (this.socket) {
      this.socket.emit('start-game', { roomId });
    }
  }

  // 새 게임 준비 요청
  requestNewGame(roomId) {
    if (this.socket) {
      this.socket.emit('request-new-game', { roomId });
    }
  }

  // 게임 완료 알림
  gameCompleted(roomId) {
    if (this.socket) {
      this.socket.emit('game-completed', { roomId });
    }
  }

  // 답변 제출
  submitAnswer(roomId, sessionId, answer) {
    if (this.socket) {
      this.socket.emit('submit-answer', { roomId, sessionId, answer });
    }
  }

  // 게임 결과 조회
  getGameResult(sessionId) {
    if (this.socket) {
      this.socket.emit('get-game-result', { sessionId });
    }
  }

  // 플레이어 행동
  playerAction(actionData) {
    if (this.socket) {
      this.socket.emit('playerAction', actionData);
    }
  }

  // 이벤트 리스너 등록
  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  // 이벤트 리스너 제거
  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  // 소켓 인스턴스 반환
  getSocket() {
    return this.socket;
  }

  // 연결 상태 확인
  isConnected() {
    return this.socket && this.socket.connected;
  }
}

// 싱글톤 인스턴스 생성
const socketService = new SocketService();

export default socketService;